export interface ExtraAPIContext {
    locals: {
        user?: {
            id?: string;
            role?: string;
            userId?: string;
        };
        runtime: {
            env: {
                USERS_CAN_REGISTER?: boolean;
            };
        };
    }
}

export function isAdminOrEditor(context?: ExtraAPIContext) {
  if (!context) {
    console.log("isAdminOrEditor: No context provided!");
    return false;
  }
  const user = context.locals.user;
  const role = user?.role?.toLowerCase() || "";
  if (role === "admin" || role === "editor") {
    return true;
  }
  return false;
}

export function isAdmin(context?: ExtraAPIContext) {
  if (!context) {
    console.log("isAdmin: No context provided!");
    return false;
  }
  const user = context.locals.user;
  const role = user?.role?.toLowerCase() || "";
  if (role === "admin") {
    return true;
  }
  return false;
}

export function isUser(context?: ExtraAPIContext, id?: string) {
  if (!context || !id) {
    console.log("isUser: No context or id provided!");
    return false;
  }

  const user = context.locals.user;
  return user?.userId === id;
}

export function isAdminOrUser(context?: ExtraAPIContext, id?: string) {
  if (!context || !id) {
    console.log("isAdminOrUser: No context or id provided!");
    return false;
  }

  return isAdmin(context) || isUser(context, id);
}

export function usersCanRegister(context?: ExtraAPIContext) {
  if (!context) {
    console.log("usersCanRegister: No context provided!");
    return false;
  }
  return context.locals.runtime.env.USERS_CAN_REGISTER?.toString() === "true" ? true : false;
}
